<template>
    <div class="addFiles">
        <label>{{title}}</label>
        <div>
            <button :class="buttonClasses()" type="button">
                Vybrat soubor
            </button>
            <span class="info" v-if="name">{{name}}</span>
            <span class="info" v-if="!name">žádný soubor nevybrán</span>
        </div>
        <div :class="'dashboardContainer-' + section"></div>
    </div>
</template>

<script>
    import Uppy from '@uppy/core';
    import Dashboard from '@uppy/dashboard';
    import XHRUpload from '@uppy/xhr-upload';
    import merge from 'lodash/merge';
    import cs_CZ from '../../service/uppy/cs_CZ';
    import {mapActions} from 'vuex';
    import {systemEnvironmentApiUrl} from "../../helpers/url";

    const restrictions = {
        restrictions: {
            maxFileSize:      1000000,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: ['image/*']
        },
    }

    export default {
        name:    'ReconstructionChallengeFileUpload',
        props:   {
            title:   {
                type:    String,
                default: null,
            },
            section: {
                type:    String,
                default: null,
            }
        },
        data() {
            return {
                name: null,
                uppy: null,
            }
        },
        mounted() {
            this.uppy = Uppy(merge({
                autoProceed: true,
                locale:      cs_CZ,
                debug:       false,
            }, restrictions));

            this.uppy.use(Dashboard, {
                trigger:                  '.uppyModalOpenerBtn-' + this.section,
                target:                   '.dashboardContainer-' + this.section,
                inline:                   false,
                replaceTargetContent:     true,
                showProgressDetails:      true,
                closeModalOnClickOutside: true,
                //browserBackButtonClose: true,
                locale:                   cs_CZ,
            });

            this.uppy.use(XHRUpload, {
                endpoint: `${systemEnvironmentApiUrl()}/api/v1/reconstruction-challenge/image`
            });

            this.uppy.on('complete', (result) => this.prepareResponse(result))
        },
        methods: {
            ...mapActions('reconstructionChallenge', ['setFile']),
            prepareResponse(result) {
                const { successful } = result;
                if (successful.length) {
                    const photo = successful[0];
                    const { name, response } = photo;
                    const { body: { fileName } } = response;

                    this.name = name;

                    this.setFile({
                        type: this.section,
                        fileName,
                    });

                    const dashboard = this.uppy.getPlugin('Dashboard')
                    if (dashboard.isModalOpen()) {
                        dashboard.closeModal()
                    }
                }
            },
            buttonClasses() {
                return 'button view-primary-light uppyModalOpenerBtn-' + this.section;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/reconstruction-challenge/FileUpload.vue